import { Route, Routes } from "react-router-dom";
import React from "react";
import Create from "../pages/Create";
import Home from "../pages/Home";
import Discover from "../pages/Discover";
import Read from "../pages/Read";
import Profile from "../pages/Profile";
import { getAuth, User } from "firebase/auth";

const HomeOrDiscover = () => {
  const [user, setUser] = React.useState<User | null>(null);
  const [authResolved, setAuthResolved] = React.useState(false);

  React.useEffect(() => {
    const unsubscribe = getAuth().onAuthStateChanged((firebaseUser) => {
      setUser(firebaseUser);
      setAuthResolved(true);
    });
    return () => unsubscribe();
  }, []);

  if (!authResolved) return null;

  return user ? <Discover /> : <Home />;
};

const PageRoutes = () => {
  React.useEffect(() => {}, []);

  return (
    <Routes>
      <Route path="/create/:id" element={<Create />} />
      <Route path="/read/:id" element={<Read />} />
      <Route path="/profile/:id" element={<Profile />} />
      <Route path="/discover" element={<Discover />} />
      <Route path="/home" element={<Home />} />
      <Route path="/" element={<HomeOrDiscover />} />
    </Routes>
  );
};

export default PageRoutes;
